import { Slug } from "../../../types/thecookies";
import { has_email, has_phone } from "./checkInputs";

export function cleanSlashInPath(path: string): string {
  if (!path) {
    return "";
  }
  return path.replace(/(https?:\/\/)|\/\//g, function (match) {
    // Conservar doble slash en "http://" o "https://", eliminar en los demás casos
    return match === "//" ? "/" : match;
  });
}

function is_containsProtocols(str: string): boolean {
  const regex = /tel:|mailto:|http/;

  return regex.test(str);
}

function setProtocolIfNeeded(str: string): string {
  if (is_containsProtocols(str)) return str;

  if (has_email(str)) return `mailto:${str}`;

  if (has_phone(str)) return `tel:${str}`;

  return str;
}

export function getLink(slug: Slug): string {
  if (typeof slug === "string") {
    if (slug === "/") return "/";
    const slugWithAddedProtocol = setProtocolIfNeeded(slug);
    if (is_containsProtocols(slugWithAddedProtocol))
      return slugWithAddedProtocol;

    return `${cleanSlashInPath(slug)}`;
  }

  return slug ? `${cleanSlashInPath(slug)}` : "undefined";
}
